import { DashboardT } from 'business/definitions';
import { formatDate } from 'helpers/formatHelper';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import PanelDetails from 'ui/Panel/PanelDetails';
import { useDashboardEventsQuery } from './hook';
import { DashboardEventT } from './type';
import DashboardEvent from './DashboardEvent';

type Props = {
    dashboard: Pick<DashboardT, 'userHistory' | 'key' | 'owner'>;
    open: boolean;
    onClose: () => void;
};

const getEventComponent = (event: DashboardEventT): React.ReactElement => {
    return <DashboardEvent {...event} />;
};

const DashboardPanelDetails = ({
    dashboard,
    open,
    onClose,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const { creationDate } = dashboard.userHistory;
    const { data: events = [] } = useDashboardEventsQuery(dashboard.key);
    return (
        <PanelDetails
            onClose={onClose}
            open={open}
            valuesToDisplay={[
                {
                    translation: t('dashboard.informations.creator'),
                    value: dashboard.userHistory.creator,
                },
                {
                    translation: t('dashboard.informations.creationDate'),
                    value: creationDate
                        ? formatDate(new Date(creationDate))
                        : ' - ',
                },
                {
                    translation: t('dashboard.informations.owner'),
                    value: dashboard.owner.displayName ?? ' - ',
                },
                {
                    translation: t(
                        'dashboard.informations.lastModificationDate',
                    ),
                    value: dashboard.userHistory.lastEvent
                        ? t('dashboard.informations.lastModificationValue', {
                              date: formatDate(
                                  new Date(
                                      dashboard.userHistory.lastEvent.date,
                                  ),
                              ),
                              user: dashboard.userHistory.lastEvent
                                  .userDisplayName,
                          })
                        : ' - ',
                },
            ]}
            headerTitle={t('dashboard.informations.title')}
            events={events}
            getEventComponent={getEventComponent}
        />
    );
};

export default DashboardPanelDetails;
